import { CardSection } from 'foundations-components/transitional/components/Card';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const CenteredTextWrapper = styled.div.withConfig({
  displayName: "HomesCardSection__CenteredTextWrapper",
  componentId: "sc-16bfv4o-0"
})(["text-align:center;"]);
const HomesCardSection = ({
  centerText = false,
  children
}) => {
  return /*#__PURE__*/_jsx(CardSection, {
    padding: "500",
    children: centerText ? /*#__PURE__*/_jsx(CenteredTextWrapper, {
      children: children
    }) : children
  });
};
export default HomesCardSection;